"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AladinError = void 0;
exports.isAladinErrorData = isAladinErrorData;
class AladinError extends Error {
    key;
    details;
    constructor(data) {
        super(data.message);
        this.key = data.key;
        this.details = data.details;
    }
}
exports.AladinError = AladinError;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function isAladinErrorData(value, key) {
    if (value === null || value === undefined) {
        return false;
    }
    if (key !== undefined) {
        return value.key === key && typeof value.message === 'string';
    }
    else {
        return typeof value.key === 'string' && typeof value.message === 'string';
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBaUNBLDhDQVNDO0FBckJELE1BQWEsV0FBeUMsU0FBUSxLQUFLO0lBQ2pELEdBQUcsQ0FBUTtJQUNYLE9BQU8sQ0FBSTtJQUUzQixZQUFZLElBQXdCO1FBQ2xDLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7UUFDbkIsSUFBSSxDQUFDLEdBQUcsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFBO1FBQ25CLElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQTtJQUM3QixDQUFDO0NBQ0Y7QUFURCxrQ0FTQztBQUVELGlIQUFpSDtBQUNqSCxTQUFnQixpQkFBaUIsQ0FBQyxLQUFVLEVBQUUsR0FBWTtJQUN4RCxJQUFJLEtBQUssS0FBSyxJQUFJLElBQUksS0FBSyxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQzFDLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztJQUNELElBQUcsR0FBRyxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQ3JCLE9BQU8sS0FBSyxDQUFDLEdBQUcsS0FBSyxHQUFHLElBQUksT0FBTyxLQUFLLENBQUMsT0FBTyxLQUFLLFFBQVEsQ0FBQTtJQUMvRCxDQUFDO1NBQU0sQ0FBQztRQUNOLE9BQU8sT0FBTyxLQUFLLENBQUMsR0FBRyxLQUFLLFFBQVEsSUFBSSxPQUFPLEtBQUssQ0FBQyxPQUFPLEtBQUssUUFBUSxDQUFBO0lBQzNFLENBQUM7QUFDSCxDQUFDIn0=